import { render } from "./Blacklist.vue?vue&type=template&id=ef63cc32"
import script from "./Blacklist.vue?vue&type=script&lang=ts"
export * from "./Blacklist.vue?vue&type=script&lang=ts"

import "./Blacklist.vue?vue&type=style&index=0&id=ef63cc32&lang=css"
script.render = render

export default script